var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,attrs:{"id":"app"}},[(_vm.envName != 'app')?_c('div',{staticClass:"env-name"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.envName))])]):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }